<template>
  <div>
    <HistoryBaseDesign
      :pageTitle="pageTitle"
      :searchHeaderInfo="searchHeaderInfo"
    >
      <template #searchDetailArea>
        <div class="px-9 py-7 d-flex">
          <div style="width: 460px">
            <InputFormNew
              v-model="searchDetailInfo.line1"
              :detail="searchDetail.line1"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="8"
            >
            </InputFormNew>
          </div>
          <div style="width: 440px" class="mt-12">
            <InputFormNew
              v-model="searchDetailInfo.line2"
              :detail="searchDetail.line2"
              :rowHeight="inputFormStyle.rowHeight"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="inputFormStyle.contentsCols"
            >
            </InputFormNew>
          </div>
        </div>
      </template>
      <template #historyList>
        <HistoryList
          :historyList="historyList"
          :headers="headers"
          :itemKey="tableKey"
          :productListHeaders="productListHeaders"
          :pagerKey="pagerKey"
          @dialogReload="rowDialogMethodCommon"
          @pageMove="execGetLoadingList"
        >
        </HistoryList>
      </template>
    </HistoryBaseDesign>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import detail from './detail'
import headers from '@/views/order/Loading/headers'

import InputFormNew from '@/components/items/Designs/InputFormNew'
import { HistoryBaseDesign, HistoryList } from '@/components/layouts'
import { commonUtil, supplierUtil } from '@/util'
import mutationTypes from '@/store/mutationTypes'
import { i18n } from '@/main'

export default {
  components: {
    HistoryBaseDesign,
    HistoryList,
    InputFormNew
  },
  data: () => {
    return {
      pageTitle: 'loading.loading_receipt-history',
      pagerKey: 'orderLoading',

      // Design
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 2,
        contentsCols: 12 - 2,
        inputItemHeight: '32px'
      },

      searchDetail: detail.detail,

      headers: headers.headers,
      tableKey: headers.tableKey,
      productListHeaders: headers.productListHeaders,

      searchHeaderInfo: {
        productName: '',
        InvalidData: true,
        checkboxLabel: 'loading.loading_not-show-invalid-loading'
      },
      searchDetailInfo: {
        line1: {
          supplierName: [],
          loadingDate: { start: '', end: '' },
          loadingStorage: {},
          loadingStatus: {}
        },
        line2: {
          orderInfo: {
            saleNumber: '',
            remittanceNumber: '',
            placeholders: [
              i18n.tc('loading.loading_target-order-number'),
              i18n.tc('loading.loading_loading-number')
            ]
          },
          productInfo: {
            number: '',
            category: {}
          }
        }
      },

      historyList: [],
      supplierNameList: []
    }
  },
  async created() {
    this.initPager()
    this.ini()
  },
  methods: {
    ...mapActions('Loading', ['getLoadingListFromApi']),
    ...mapMutations('UI', [
      mutationTypes.UI_SET_PAGE,
      mutationTypes.UI_SET_PAGE_COUNT
    ]),
    async ini() {
      // 初期表示用の設定
      this.searchDetailInfo.line1.loadingDate = {
        start: commonUtil.getFirstDateOneMonthAgo(),
        end: commonUtil.getLastDateThisMonth()
      }
      await this.execGetLoadingList()
    },

    async execGetLoadingList() {
      await supplierUtil.getSupplier() // SP01 仕入先一覧取得

      const shipList = await this.getLoadingListFromApi({
        pageType: 'LoadingHistory',
        searchParameter: {
          searchDetailInfo: this.searchDetailInfo,
          searchHeaderInfo: this.searchHeaderInfo,
          page: this.pageInfo[this.pagerKey].page
        }
      })
      const tmp = shipList.data.slice()
      tmp
        .sort((a, b) => {
          const keyName = 'loadingId'
          if (a[keyName] < b[keyName]) return 1
          if (a[keyName] > b[keyName]) return -1
          return 0
        })
        .map((ele, Index) => {
          ele.panelIndex = Index + 1
          ele.beforeCompleteFlgTmp = this.getBeforeCompleteFlgTmp(ele)
          return ele
        })
      this.historyList = tmp
    },
    getBeforeCompleteFlgTmp(rec) {
      return false
    },
    rowDialogMethodCommon(...args) {
      const [dialogName, info] = args

      this.ini()
    },
    initPager() {
      this[mutationTypes.UI_SET_PAGE]({ index: 1, key: this.pagerKey })
      this[mutationTypes.UI_SET_PAGE_COUNT]({ length: 1, key: this.pagerKey })
    }
  },
  computed: {
    ...mapGetters('UI', ['pageInfo'])
  },
  watch: {
    searchDetailInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.initPager()
        this.execGetLoadingList()
      }
    },
    searchHeaderInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.initPager()
        this.execGetLoadingList()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.inputFormStyle {
  &::v-deep {
    .MultipleSelectSupplierName {
      width: 822px;
    }
  }
}
</style>
